function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3125 0H0.9375C0.418945 0 0 0.418945 0 0.9375V19.6875C0 20.2061 0.418945 20.625 0.9375 20.625H25.3125C25.8311 20.625 26.25 20.2061 26.25 19.6875V0.9375C26.25 0.418945 25.8311 0 25.3125 0ZM22.9453 3.19043L13.7021 10.3828C13.4736 10.5615 13.1543 10.5615 12.9258 10.3828L3.67969 3.19043C3.64483 3.16353 3.61927 3.1264 3.60658 3.08424C3.59389 3.04208 3.5947 2.99701 3.60892 2.95534C3.62313 2.91367 3.65003 2.87749 3.68583 2.85188C3.72164 2.82626 3.76457 2.81249 3.80859 2.8125H22.8164C22.8604 2.81249 22.9034 2.82626 22.9392 2.85188C22.975 2.87749 23.0019 2.91367 23.0161 2.95534C23.0303 2.99701 23.0311 3.04208 23.0184 3.08424C23.0057 3.1264 22.9802 3.16353 22.9453 3.19043Z",
  fill: "#84D6D1"
});

function SvgMailLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/mailLogo.b2e4bfd9.svg";
export { ForwardRef as ReactComponent };